import { components } from "types/declarations/api";

type LeadAssignment = components["schemas"]["LeadAssignmentViewModel"];
type StoreWithName = components["schemas"]["StoreViewModel"] & {
	storeName?: string | null;
};

const getTrimmedValue = (value?: string | null): string | null => {
	const trimmedValue = value?.trim();
	return trimmedValue || null;
};

export const getAssignedToLocation = (leadAssignment?: LeadAssignment): string | null => {
	if (!leadAssignment) return null;

	const store = leadAssignment.store as StoreWithName | undefined;

	return (
		getTrimmedValue(store?.storeName) ??
		getTrimmedValue(store?.storeInfo?.name) ??
		getTrimmedValue(leadAssignment.storeId) ??
		getTrimmedValue(leadAssignment.lead?.storeId)
	);
};
